// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2b5sC","info":"Note_info__bg72f","note":"Note_note__X8wI6","actions":"Note_actions__2r7LU"};